"use client";

import { useEffect, useState } from "react";

export type Platform = "ios" | "android" | "desktop";

/**
 * Détecte la plateforme côté client (pattern Lyft).
 * Rend "desktop" au premier rendu (SSR-safe) puis se met à jour.
 */
export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>("desktop");

  useEffect(() => {
    try {
      const ua = navigator.userAgent || navigator.vendor || "";
      if (/android/i.test(ua)) {
        setPlatform("android");
      } else if (
        /iPad|iPhone|iPod/i.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      ) {
        setPlatform("ios");
      } else {
        setPlatform("desktop");
      }
    } catch {
      setPlatform("desktop");
    }
  }, []);

  return platform;
}
